/* CITRIN swatch sync for product cards (sibling colour swatches).
   Was printed inline after EVERY product card (~18 KB each time); now one cached file.
   Behaviour unchanged - see git history of snippets/product-grid-item.liquid (Aug-Oct 2026) for the full notes.
   Oct 2026 (speed): other colours are fetched on first hover/tap instead of shipped hidden in the page. */
(function(){
  if (window.__citrinSwatchCutlineSync) return;
  window.__citrinSwatchCutlineSync = true;

  var isTouch = window.matchMedia('(hover: none)').matches;

  if (isTouch && !window.__citrinSwatchTouchGlobals) {
    window.__citrinSwatchTouchGlobals = true;
    var citrinStyle = document.createElement('style');
    citrinStyle.textContent =
      'product-grid-item.citrin-swatches-open .grid__swatch__container .grid__swatch__hover,' +
      'product-grid-item.citrin-swatches-open .sibs__slider .grid__swatch__hover,' +
      'product-grid-item.citrin-swatches-open .grid__swatch__container .tabs__arrow,' +
      'product-grid-item.citrin-swatches-open .sibs__slider .tabs__arrow{' +
      'visibility:visible;opacity:1;pointer-events:auto;}' +
      'product-grid-item.citrin-swatches-open .grid__swatch__placeholder{' +
      'visibility:hidden;opacity:0;}';
    document.head.appendChild(citrinStyle);

    document.addEventListener('click', function(e){
      document.querySelectorAll('product-grid-item.citrin-swatches-open').forEach(function(open){
        if (!open.contains(e.target)) open.classList.remove('citrin-swatches-open');
      });
    });

    document.addEventListener('click', function(e){
      var target = e.target;
      if (!target || !target.closest) return;

      var placeholderEl = target.closest('product-grid-item .grid__swatch__placeholder');
      if (placeholderEl) {
        var pCard = placeholderEl.closest('product-grid-item');
        if (pCard) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('product-grid-item.citrin-swatches-open').forEach(function(open){
            if (open !== pCard) open.classList.remove('citrin-swatches-open');
          });
          pCard.classList.add('citrin-swatches-open');
          prefetchCard(pCard);
          try { placeholderEl.focus(); } catch(err) {}
        }
        return;
      }

      var link = target.closest('.siblings__link[data-sibling-cutline]');
      if (link) {
        var card = link.closest('product-grid-item');
        if (!card) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!card.__citrinApply) bindCard(card);
        if (card.__citrinApply) card.__citrinApply(link);
        return;
      }

      var more = target.closest('[data-swatch-more-link]');
      if (more) {
        var mCard = more.closest('product-grid-item');
        if (mCard && mCard.hasAttribute('data-prevent-swatch-navigation')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }, true);
  }

  /* Speed (Oct 2026): hidden colour copies ship their Quick add buttons inside a <template>
     (not built until needed). Build them the first time that colour is shown. */
  function materialize(block){
    var t = block.querySelector('template[data-citrin-lazy-qa]');
    if (!t || !t.parentNode) return;
    t.parentNode.replaceChild(t.content.cloneNode(true), t);
  }
  window.__citrinMaterializeQuickAdd = materialize;

  /* Speed (Oct 2026): cards now print only the colour on show. Every other sibling colour is an
     empty <div data-citrin-lazy-card="handle" data-grid-item-variant="id" hidden> placeholder, and the
     real copy is fetched from sections/citrin-card-variant.liquid the first time it is wanted
     (hover on desktop = it is usually ready before the click). */
  var LAZY_SECTION = 'citrin-card-variant';

  function cardBlocks(card){
    return card.querySelectorAll('product-grid-item-variant[data-grid-item-variant], [data-citrin-lazy-card][data-grid-item-variant]');
  }

  function runScripts(root){
    root.querySelectorAll('script').forEach(function(old){
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.text = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function copySizes(card, el){
    var ref = card.querySelector('product-grid-item-variant:not([hidden]) img[sizes]');
    var sizes = ref && ref.getAttribute('sizes');
    if (!sizes) return;
    function fix(root){
      root.querySelectorAll('img[sizes], source[sizes]').forEach(function(n){ n.setAttribute('sizes', sizes); });
      root.querySelectorAll('template').forEach(function(t){ fix(t.content); });
    }
    fix(el);
  }

  function loadLazy(card, placeholder){
    if (placeholder.__citrinLoad) return placeholder.__citrinLoad;
    var handle = placeholder.getAttribute('data-citrin-lazy-card');
    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    placeholder.__citrinLoad = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + LAZY_SECTION)
      .then(function(r){ if (!r.ok) throw new Error('citrin card ' + r.status); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var found = doc.querySelector('product-grid-item-variant[data-grid-item-variant]');
        if (!found || !placeholder.parentNode) throw new Error('citrin card: no markup');
        var el = document.importNode(found, true);
        el.setAttribute('hidden', '');
        copySizes(card, el);
        placeholder.parentNode.replaceChild(el, placeholder);
        runScripts(el);
        /* Warm the main photo too, so the swatch shows it straight away instead of fading in. */
        var mainImage = el.querySelector('product-grid-item-image');
        if (mainImage) mainImage.setAttribute('loading', 'eager');
        var mainImg = el.querySelector('img');
        if (mainImg) mainImg.setAttribute('loading', 'eager');
        return el;
      })
      .catch(function(){
        placeholder.__citrinFailed = true;
        return null;
      });
    return placeholder.__citrinLoad;
  }

  /* Start fetching a card's other colours as soon as the shopper shows interest in that card
     (pointer over the card on desktop, swatch row opened on phones), so the photo is usually
     ready by the time a swatch is reached. */
  function prefetchCard(card){
    card.querySelectorAll('[data-citrin-lazy-card]').forEach(function(p){ loadLazy(card, p); });
  }

  function bindCard(card){
    if (card.__citrinSwatchBound) return;
    card.__citrinSwatchBound = true;

    var mainLink = card.querySelector('[data-grid-info-link]');
    var cutlineEl = card.querySelector('[data-citrin-cutline]');
    var titleEl = card.querySelector('[data-citrin-title]');
    var priceWrap = card.querySelector('[data-citrin-price-wrap]');
    var soldWrap = card.querySelector('[data-citrin-sold-wrap]');
    var swatchLinks = card.querySelectorAll('.siblings__link[data-sibling-cutline]');
    var moreLink = card.querySelector('[data-swatch-more-link]');
    if (!mainLink || swatchLinks.length === 0) return;

    var preventNav = card.hasAttribute('data-prevent-swatch-navigation');

    if (moreLink && preventNav) {
      moreLink.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    var anchorHref = mainLink.getAttribute('href');
    var anchorCutline = cutlineEl ? cutlineEl.getAttribute('data-anchor-cutline') : null;
    var anchorTitle = titleEl ? titleEl.getAttribute('data-anchor-title') : null;
    var anchorPriceHtml = priceWrap ? priceWrap.innerHTML : null;
    var anchorSoldHtml = soldWrap ? soldWrap.innerHTML : null;
    var anchorVariantId = null;
    cardBlocks(card).forEach(function(block){
      if (!block.hasAttribute('hidden')) anchorVariantId = block.getAttribute('data-grid-item-variant');
    });

    function tallestAcrossSiblings(el, attr, anchorHTML, useTextContent){
      if (!el) return 0;
      var max = el.getBoundingClientRect().height;
      var original = useTextContent ? el.textContent : el.innerHTML;
      swatchLinks.forEach(function(link){
        var value = link.getAttribute(attr);
        if (value === null) return;
        if (useTextContent) { el.textContent = value; } else { el.innerHTML = value; }
        var h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });
      if (useTextContent) { el.textContent = original; } else { el.innerHTML = original; }
      return max;
    }

    if (titleEl) titleEl.style.minHeight = tallestAcrossSiblings(titleEl, 'data-sibling-title', null, true) + 'px';
    if (priceWrap) priceWrap.style.minHeight = tallestAcrossSiblings(priceWrap, 'data-sibling-price-html', null, false) + 'px';
    if (soldWrap) soldWrap.style.minHeight = tallestAcrossSiblings(soldWrap, 'data-sibling-sold-html', null, false) + 'px';

    var wantedVariantId = anchorVariantId;

    function showVariant(variantId){
      var blocks = cardBlocks(card);
      if (!variantId || blocks.length < 2) return;
      wantedVariantId = variantId;
      var target = null;
      blocks.forEach(function(block){
        if (block.getAttribute('data-grid-item-variant') === variantId) target = block;
      });
      if (!target) return;
      if (target.hasAttribute('data-citrin-lazy-card')) {
        /* Not fetched yet: keep the current photo until the colour arrives, then show it
           if that colour is still the one wanted (the shopper may have moved on). */
        loadLazy(card, target).then(function(el){
          if (el && wantedVariantId === variantId) showVariant(variantId);
        });
        return;
      }
      blocks.forEach(function(block){
        if (block === target) {
          materialize(block);
          block.removeAttribute('hidden');
        } else {
          block.setAttribute('hidden', '');
        }
      });
    }

    function apply(link){
      var href = link.getAttribute('href');
      var cutline = link.getAttribute('data-sibling-cutline');
      var title = link.getAttribute('data-sibling-title');
      var priceHtml = link.getAttribute('data-sibling-price-html');
      var soldHtml = link.getAttribute('data-sibling-sold-html');
      var variantId = link.getAttribute('data-sibling-variant-id');
      if (href) mainLink.setAttribute('href', href);
      if (cutlineEl) cutlineEl.textContent = cutline || '';
      if (titleEl && title) titleEl.textContent = title;
      if (priceWrap && priceHtml !== null) priceWrap.innerHTML = priceHtml;
      if (soldWrap && soldHtml !== null) soldWrap.innerHTML = soldHtml;
      showVariant(variantId);
    }

    function revertToAnchor(){
      mainLink.setAttribute('href', anchorHref);
      if (cutlineEl && anchorCutline !== null) cutlineEl.textContent = anchorCutline;
      if (titleEl && anchorTitle !== null) titleEl.textContent = anchorTitle;
      if (priceWrap && anchorPriceHtml !== null) priceWrap.innerHTML = anchorPriceHtml;
      if (soldWrap && anchorSoldHtml !== null) soldWrap.innerHTML = anchorSoldHtml;
      showVariant(anchorVariantId);
    }

    var lockedLink = null;

    function revert(){
      if (lockedLink) {
        apply(lockedLink);
        return;
      }
      revertToAnchor();
    }

    card.__citrinApply = apply;
    card.__citrinRevert = revert;

    if (!isTouch) {
      var swatchRow = card.querySelector('.grid__swatch__hover') || card;
      swatchLinks.forEach(function(link){
        link.addEventListener('mouseenter', function(){ apply(link); });
        link.addEventListener('focus', function(){ apply(link); });
        link.addEventListener('blur', revert);
        if (preventNav) {
          link.addEventListener('click', function(e){
            e.preventDefault();
            lockedLink = link;
            apply(link);
          });
        }
      });
      swatchRow.addEventListener('mouseleave', revert);
      card.addEventListener('mouseenter', function(){ prefetchCard(card); }, {once: true});
    } else {
      var placeholderEl = card.querySelector('.grid__swatch__placeholder');
      if (placeholderEl) {
        placeholderEl.setAttribute('tabindex', '0');
        placeholderEl.setAttribute('role', 'button');
      }
    }
  }

  function bindAll(){
    document.querySelectorAll('product-grid-item').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('theme:cart:reload', bindAll);
  document.addEventListener('citrin:swatch:rebind', bindAll);

  if ('MutationObserver' in window) {
    var citrinGridObserver = new MutationObserver(function(mutations){
      var needsBind = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'PRODUCT-GRID-ITEM' || (node.querySelector && node.querySelector('product-grid-item'))) {
            needsBind = true;
            break;
          }
        }
        if (needsBind) break;
      }
      if (needsBind) bindAll();
    });
    citrinGridObserver.observe(document.body, {childList: true, subtree: true});

    /* Safety net: if anything else un-hides a colour copy, build its Quick add too. */
    new MutationObserver(function(recs){
      for (var i = 0; i < recs.length; i++) {
        var el = recs[i].target;
        if (el.tagName === 'PRODUCT-GRID-ITEM-VARIANT' && !el.hasAttribute('hidden')) materialize(el);
      }
    }).observe(document.body, {attributes: true, attributeFilter: ['hidden'], subtree: true});
  }
})();
